export default class Journey {
    constructor (
        id,
        hardwareId,
        organizationId,
        fleetId,
        vehicleId,
        driverId,
        driverName,
        startPoint,
        endPoint,
        lengthMeters,
        noGps,
        journeyType,
        idlePts,
        noGpsEvents,
        type
    ) {
        this.id = id
        this.hardwareId = hardwareId
        this.organizationId = organizationId
        this.fleetId = fleetId
        this.vehicleId = vehicleId
        this.driverId = driverId
        this.driverName = driverName
        this.startPoint = startPoint
        this.endPoint = endPoint
        this.lengthMeters = lengthMeters
        this.noGps = noGps
        this.journeyType = journeyType
        this.idlePts = idlePts
        this.noGpsEvents = noGpsEvents
        this.type = type
        this.events = []
        this.medias = []
        this.telemetryExtended = null
    }
}
